import { render, staticRenderFns } from "./ServiceCompanies.vue?vue&type=template&id=c761f1be&"
import script from "./ServiceCompanies.vue?vue&type=script&lang=ts&"
export * from "./ServiceCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports